import {
  BsTag,
  BsCashStack,
  BsPerson,
  BsBuilding,
  BsFileText,
  BsTrash,
  BsPencilSquare,
  BsPlus,
  BsClock,
} from 'react-icons/bs'
import { LiaHandHoldingUsdSolid } from 'react-icons/lia'
import { EventIconProps } from './types'

export function EventIcon({ contentType, actionType }: EventIconProps) {
  const iconClass = 'w-5 h-5 text-new-company-gray-900'

  // Map content type model and action type to specific icons
  if (actionType === 'DELETE') {
    return <BsTrash className={iconClass} />
  }

  if (actionType === 'ADD' || actionType === 'REMOVE') {
    switch (contentType.model) {
      case 'contactcompany':
        return <BsBuilding className={iconClass} />
      case 'contact':
        return <BsPerson className={iconClass} />
      default:
        return <BsPlus className={iconClass} />
    }
  }

  switch (contentType.model) {
    case 'campaign':
      return <BsTag className={iconClass} />
    case 'deal':
      return <BsCashStack className={iconClass} />
    case 'companynote':
    case 'note':
    case 'contactnote':
    case 'doornote':
      return <BsFileText className={iconClass} />
    case 'reminder':
      return <BsClock className={iconClass} />
    case 'contactcompany':
      return <BsBuilding className={iconClass} />
    case 'contact':
      return <BsPerson className={iconClass} />
    case 'gpo':
    case 'distributor':
      return <BsCashStack className={iconClass} />
    case 'sample':
    case 'samplerequest':
      return <LiaHandHoldingUsdSolid className={iconClass} />
    default:
      if (actionType === 'UPDATE') {
        return <BsPencilSquare className={iconClass} />
      }
      return <BsTag className={iconClass} />
  }
}
